module.exports = __webpack_public_path__ + "img/user.2adbf9dd.svg";